import type { MouseEventHandler } from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@volca/ui/lib/utils";
import { type ApTabValue, invoiceReviewPath } from "@/accounts-payable/utils";

/** Only the invoice number is interactive, so card actions cannot open it. */
export const InvoiceCardTitleLink = ({
  invoiceId,
  vendorName,
  invoiceNumber,
  fromTab,
  className,
  onClick,
}: {
  invoiceId: string;
  vendorName: string;
  invoiceNumber: string;
  fromTab: ApTabValue;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}) => {
  const { search } = useLocation();
  return (
    <Link
      to={invoiceReviewPath(invoiceId, fromTab, search)}
      onClick={onClick}
      aria-label={`Review ${vendorName} invoice ${invoiceNumber}`}
      className={cn(
        "rounded-sm text-link underline decoration-link/40 underline-offset-2 outline-none hover:decoration-link focus-visible:ring-3 focus-visible:ring-focus/50",
        className,
      )}
    >
      {invoiceNumber}
    </Link>
  );
};
